export const PHONE_DISPLAY = "020 8087 0906";
export const PHONE_HREF = "tel:02080870906";

const base = (import.meta.env.BASE_URL || "/").replace(/\/$/, "");
export const img = (p: string) => `${base}/images/${p}`;

export type LocationCtx = {
  areaLinks?: Record<string, string>;
  service: { title: string; slug?: string };
  city: { title: string; slug?: string; region?: string };
  sublocation?: { title: string; slug?: string; citySlug?: string } | null;
};

export function isLocationCtx(ctx: any): ctx is LocationCtx {
  return !!(ctx && ctx.service?.title && ctx.city?.title);
}

export function placeName(ctx: LocationCtx) {
  return ctx.sublocation?.title ? `${ctx.sublocation.title}, ${ctx.city.title}` : ctx.city.title;
}

export function heroImageFor(ctx: LocationCtx) {
  const s = `${ctx.service.slug || ""} ${ctx.service.title}`.toLowerCase();
  if (s.includes("repair")) return img("repair.webp");
  if (s.includes("mainten") || s.includes("servic")) return img("home/engineer.webp");
  if (s.includes("vent") || s.includes("duct")) return img("home/vent-pipes.webp");
  if (s.includes("commercial")) return img("commercial.webp");
  return img("install.webp");
}

export const SECTORS = [
  { title: "Homes", desc: "Quiet wall and floor units for bedrooms, lofts, extensions and open-plan living.", src: img("install-home.webp") },
  { title: "Offices", desc: "Multi-room and ceiling cassette systems sized to occupancy and heat load.", src: img("install-office.webp") },
  { title: "Shops & retail", desc: "Comfortable shop floors that keep customers and staff cool through summer.", src: img("install-shop.webp") },
  { title: "Restaurants", desc: "Systems specified to cope with kitchen heat and busy dining rooms.", src: img("install-restaurant.webp") },
  { title: "Healthcare", desc: "Filtered, controllable air for clinics, surgeries and treatment rooms.", src: img("install-healthcare.webp") },
];
